<template>
	<div>
<!--		 :class="{hideSection : !pageSetting.detail}"-->
    <div class="vh-100" v-if="pageSetting.detail">
        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left" @click="backrekapabsen">
                    <div class="header-item">
                        <img src="../../../assets/icons/back-blue.svg" alt="a">
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Detail Absensi</div>
                <div class="header-top--right">
                    <div class="header-item">
                    </div>
                </div>
            </div>
        </div>
        <!-- CONTENT -->
        <div class="content-wrapper main-page">
            <div class="w-limit">
                <div class="p-x-20 p-y-16">
                    <div class="wrapper">
                        <div class="form-label">Tanggal</div>
                        <div class="f-16">{{Date_rekap}}</div>
                    </div>
                    <div class="d-flex-between-center m-t-16">
                        <div class="wrapper">
                            <div class="form-label">Status</div>
                            <div class="f-16" v-if="status==='0'">Tanpa Status</div>
                            <div class="f-16" v-if="status==='1'">Masuk Kerja</div>
                            <div class="f-16 f-c-red" v-if="status==='2'">Alpha</div>
                            <div class="f-16 f-c-red" v-if="status==='3'">Cuti</div>
                            <div class="f-16 f-c-red" v-if="status==='4'">Sakit</div>
                            <div class="f-16 f-c-red" v-if="status==='5'">Libur</div>
                        </div>
                        <button v-if="validateAccess('attendance.update')" class="btn btn-outline-small" data-toggle="modal" data-target="#modalnotif">Ubah Status
                        </button>
                    </div>

                </div>
	            <div class="separator-line"></div>

	            <div v-if="status === '1'">
		            <div class="p-x-20 p-y-16 container jam-kerja-wrapper">
			            <div class="f-regular f-14">
				            <span class="f-c-midgrey">Tempat: </span>
				            <span class="f-c-black">{{ dataKaryawan.lokasi_absensi }}</span>
			            </div>

			            <div class="f-regular f-14 f-c-midgrey p-t-12" v-if="masuk_kerja === ' --:-- '">
				            —  Tidak/belum ada data absen masuk
			            </div>
			            <div class="d-flex-between-center p-t-12" v-else>
				            <div class="thumbnail-detail-absen"
				                 v-if="dataKaryawan.cloudnameIn !== ''"
				                 :style="{backgroundImage: 'url(' + fotoAbsenMasuk + ')'}"
				                 @click="showFotoAbsen('url(' + fotoAbsenMasuk + ')')"
				            >
					            <img src="../../../assets/icons/expand-photo.svg" alt="" class="icon-expand-photo">
				            </div>
				            <div class="thumbnail-detail-absen" v-else>
					            <img src="../../../assets/icons/ownerprofile.png" alt="" class="icon-expand-photo" style="height: 80px">
				            </div>
				            <div class="info-absen"
				                 @click="() => { dataKaryawan.alamat_kordinat_masuk !== '' ? showDetailLokasiAbsen(dataKaryawan.lat_masuk, dataKaryawan.lng_masuk) : '' }">
					            <div class="d-block w-100" style="padding-left: 12px">
						            <div class="f-16 f-regular">Masuk {{ this.getDateWithTimezone(dataKaryawan.masuk_raw, "HH:mm", this.getUserTimezone()) }}</div>
						            <div class="f-14 f-regular f-c-midgrey nomore">{{ dataKaryawan.alamat_kordinat_masuk }}</div>
						            <div class="f-14 f-semi f-c-blue" v-if="dataKaryawan.alamat_kordinat_masuk !== ''">Lihat Lokasi <img src="../../../assets/icons/ic_baseline-arrow-back.svg" alt=""></div>
						            <div class="f-14 f-semi f-c-midgrey" v-else>Tidak ada Lokasi</div>
					            </div>
				            </div>
			            </div>
		            </div>
		            <div class="separator-line"></div>
		            <div class="p-x-20 p-y-16 container jam-kerja-wrapper">
			            <div class="f-regular f-14 f-c-midgrey" v-if="pulang_kerja === ' --:-- '">
				            —  Tidak/belum ada data absen pulang
			            </div>
			            <div class="d-flex-between-center" v-else>
				            <div class="thumbnail-detail-absen"
				                 v-if="dataKaryawan.cloudnameOut !== ''"
				                 :style="{backgroundImage: 'url(' + fotoAbsenKeluar + ')'}"
				                 @click="showFotoAbsen('url(' + fotoAbsenKeluar + ')')"
				            >
					            <img src="../../../assets/icons/expand-photo.svg" alt="" class="icon-expand-photo">
				            </div>
				            <div class="thumbnail-detail-absen" v-else>
					            <img src="../../../assets/icons/ownerprofile.png" alt="" class="icon-expand-photo" style="height: 80px">
				            </div>
				            <div class="info-absen"
				                 @click="() => { dataKaryawan.alamat_kordinat_pulang !== '' ? showDetailLokasiAbsen(dataKaryawan.lat_pulang, dataKaryawan.lng_pulang) : ''}">
					            <div class="d-block w-100" style="padding-left: 12px">
						            <div class="f-16 f-regular">Pulang {{ getDateWithTimezone(dataKaryawan.pulang_raw, "HH:mm", getUserTimezone()) }}</div>
						            <div class="f-14 f-regular f-c-midgrey nomore">{{ dataKaryawan.alamat_kordinat_pulang }}</div>
						            <div class="f-14 f-semi f-c-blue" v-if="dataKaryawan.alamat_kordinat_pulang !== ''">Lihat Lokasi <img src="../../../assets/icons/ic_baseline-arrow-back.svg" alt=""></div>
						            <div class="f-14 f-semi f-c-midgrey" v-else>Tidak ada Lokasi</div>
					            </div>
				            </div>
			            </div>
		            </div>
	            </div>

	            <div v-else-if="status === '0'">
		            <div class="p-x-20 p-y-16 tanpa-status-wrapper" id="tanpa_status">
			            <div class="f-14 f-c-midgrey">
				            ‘Tanpa status’ merupakan status yang diberikan jika karyawan tidak melakukan absen. Anda bisa
				            mengubahnya.
			            </div>
		            </div>
	            </div>
            </div>
            <div class="nav-bottom-wrapper ">
	            <div class="p-x-20 p-y-12 d-flex-between-center w-limit border-top">
		            <div class="f-16 f-c-midgrey" v-html="dataKaryawan.sumber_data"></div>
	            </div>
                <div class="p-x-20 p-y-12 d-flex-between-center w-limit border-top">
                    <div id="buttonKemarin" class="f-c-blue d-flex align-items-center"
                         v-if="dateButton.yesterday"
                         @click="buttonKemarin"
                    >
                        <div class="m-r-4 icon-16 icon-left-blue"></div>
                        <div class="f-16 f-semi">Kemarin</div>
                    </div>
	                <div class="f-c-blue d-flex align-items-center"
	                     v-else
	                >
		                <div class="m-r-4 icon-16 icon-right-grey" style="transform: rotate(180deg)"></div>
		                <div class="f-16 f-semi f-c-midgrey">Kemarin</div>
	                </div>

	                <div id="buttonHariIni" class="f-c-blue d-flex align-items-center"
	                     v-if="dateButton.showToday"
	                >
		                <div class="f-16 f-semi" @click="buttonHariIni" v-if="!dateButton.today">Hari Ini</div>
		                <div class="f-16 f-semi f-c-midgrey" v-else>Hari Ini</div>
	                </div>

	                <div id="buttonBesok" class="f-c-blue d-flex align-items-center"
	                     v-if="dateButton.tomorrow"
	                     @click="buttonBesok"
	                >
                        <div class="f-16 f-semi">Besok</div>
                        <div class="m-l-4 icon-16 icon-right-blue"></div>
                    </div>
	                <div class="f-c-blue d-flex align-items-center"
	                     v-else
	                >
		                <div class="f-16 f-semi f-c-midgrey">Besok</div>
		                <div class="m-l-4 icon-16 icon-right-grey"></div>
	                </div>
                </div>
            </div>
        </div>
        <!-- MODAL -->
        <div class="modal fade" id="modalnotif" role="dialog">
            <div class="modal-dialog modal-lg  bani-modal">
                <div class="modal-content">
                    <div class="modal-head w-limit">
                        <div class="modal-head--left"></div>
                        <h5 class="f-16 f-bold">Ubah Status Absensi</h5>
                        <div class="modal-head--right" data-dismiss="modal">
                            <img src="../../../assets/img/x2.svg" alt="">
                        </div>
                    </div>
                    <div class="separator-line"></div>
                    <div class="modal-bodyy w-limit w-100 p-x-20">
                        <div class="form-group mod m-t-16">
                            <label for="exampleFormControlSelect1" class="form-label">Status</label>
                            <select class="form-control right-icon icon-dropdown" id="exampleFormControlSelect1"
                                    v-model="selectedabsen" @change="cekvalidatemodal">
                                <option value="" selected>Pilih Status</option>
                                <option value="1">Masuk Kerja</option>
                                <option value="2">Alpha</option>
                                <option value="3">Cuti</option>
                                <option value="4">Sakit</option>
                                <option value="5">Libur</option>
                                <option value="0">Tanpa Status</option>
                            </select>
	                        <ErrorMessage class="error" label="Status" :validation="$v.selectedabsen"></ErrorMessage>
                        </div>
                        <div class="m-t-16 d-flex" v-if="selectedabsen=='1'">
                            <div class="form-group mod flex-1">
                                <label for="waktu_masuk" class="form-label">Waktu Masuk</label>
                                <input type="time" class="form-control" id="waktu_masuk"
                                       v-model="time_awal" @change="cekvalidatemodal">
	                            <ErrorMessage class="error" label="Waktu Masuk" :validation="$v.time_awal"></ErrorMessage>
                            </div>
                            <div class="m-l-8 form-group mod flex-1">
                                <label for="waktu_pulang" class="form-label">Waktu Pulang</label>
                                <input type="time" class="form-control" id="waktu_pulang"
                                       v-model="time_akhir" @change="cekvalidatemodal">
	                            <ErrorMessage class="error" label="Waktu Pulang" :validation="$v.time_akhir"></ErrorMessage>
                            </div>
                        </div>
                        <div class="button-wrapper m-t-4 p-y-20 w-limit w-100">
                            <button class="btn smart-primary" id="BtnDetailAbsen" @click="UpdateStatus">
                                Simpan
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="loadingPages" style="display: none">
            <span class="spinner-border spinner-border-sm-loader" role="status" aria-hidden="true"></span>
        </div>

    </div>
		<FotoAbsen v-if="pageSetting.absensi" :fotoAbsensi="fotoAbsensi" @back="showDetailAbsensi" />
		<LokasiAbsen v-if="pageSetting.maps" :latlng="latlng" @back="showDetailAbsensi" />
	</div>
</template>
<script>
	import ErrorMessage from "@/component-items/ErrorMessage";
	import FotoAbsen from "@/components/Karyawan/Absensi/FotoAbsen";
	import LokasiAbsen from "@/components/Karyawan/Absensi/LokasiAbsen";
	import {required} from "vuelidate/lib/validators";

    export default {
        name: 'DetailAbsen',
	    components: { ErrorMessage, FotoAbsen, LokasiAbsen },
        data() {
            return {
                tanggalAwal :this.datarekapdetail.tanggalAwal,
                tanggalAkhir:this.datarekapdetail.tanggalAkhir,
                tanggalPage:this.datarekapdetail.tanggal_format,
                Date_rekap: '',
                Date_post: '',
                status: 0,
                masuk_kerja: '',
                pulang_kerja: '',
                Data_Detail: [],
                time_awal: '',
                time_akhir: '',
                idlokasi: '',
                lokasi: 0,
                idkaryawan: '',
                selectedabsen: '',
	            dataKaryawan: {},
	            fotoAbsenMasuk: "",
				fotoAbsenKeluar: "",
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },

                pageSetting: {
                	detail: true,
                	absensi: false,
	                maps: false,
                },
	            fotoAbsensi: "",
	            latlng: {
                	lat: 0,
		            lng: 0,
	            },

	            dateButton: {
                	tomorrow: false,
		            yesterday: false,
		            today: false,
		            showToday: false,
	            }
            }
        },
	    validations: {
		    selectedabsen: {
		    	required,
		    },
		    time_awal: {
		    	required
		    },
		    time_akhir: {
		    	required
		    },
	    },
        props: ['datarekapdetail', 'datarekap'],
        mounted() {
            this.gettimetoday();
            this.timenow();
            this.GetDetailAbsensiz();
            this.timenowakhir();
            this.gettimetodayakhir();
            this.cekvalidatemodal();

            // console.log(this.$moment("2020-02-03").isSame(this.$moment(), "day"))
	        // console.log(this.$moment("2021-01-02").month())
        },
        methods: {
            backrekapabsen() {
                var idkaryawan = this.datarekap.idkaryawan;
                this.$emit('showrekapabsen', this.datarekap)
            },
            buttonKemarin() {
                var tanggalOnPage = this.tanggalPage
                var d = new Date(tanggalOnPage);
                d.setDate(d.getDate() - 1);
                var theDateReduced = d.toLocaleDateString('ja', {
                    year:  'numeric',
                    month: '2-digit',
                    day:   '2-digit'
                }).replace(/\//g, '-')
                this.GetDetailAbsensiChangePage(theDateReduced);
            },
            buttonBesok() {
                var tanggalOnPage = this.tanggalPage
                var d = new Date(tanggalOnPage);
                d.setDate(d.getDate() + 1);
                var theDateAdded = d.toLocaleDateString('ja', {
                    year:  'numeric',
                    month: '2-digit',
                    day:   '2-digit'
                }).replace(/\//g, '-')
                this.GetDetailAbsensiChangePage(theDateAdded);
            },
	        buttonHariIni() {
		        this.GetDetailAbsensiChangePage(this.$moment().format("YYYY-MM-DD"));
	        },
            cekvalidatemodal() {
                // this.status = this.selectedabsen;
                var selectLayanan = this.time_awal;
                var selectLayanan1 = this.time_akhir;
                var selectLayanan2 = this.selectedabsen;
                if (selectLayanan !== '' && selectLayanan1 >= selectLayanan && selectLayanan2 !== '') {
                    // $('#BtnDetailAbsen').prop('disabled', false);
                } else {
                    // $('#BtnDetailAbsen').prop('disabled', true);
                }
            },
            gettimetoday() {
                $('#waktu_masuk').attr('min', this.time_awal);
            },
            timenow() {
                var today = new Date();
                var HH = today.getHours();
                var minutes = today.getMinutes()
                if (minutes < 10) {
                    minutes = "0" + minutes
                }
                if (HH < 10) {
                    HH = "0" + HH
                }
                today = HH + ':' + minutes;
                this.time_awal = today;
            },
            gettimetodayakhir() {
                $('#waktu_pulang').attr('max', this.time_akhir);
            },
            timenowakhir() {
                var today = new Date();
                var HH = today.getHours();
                var minutes = today.getMinutes()
                if (minutes < 10) {
                    minutes = "0" + minutes
                }
                if (HH < 10) {
                    HH = "0" + HH
                }
                today = HH + ':' + minutes;
                this.time_akhir = today;
            },
            async GetDetailAbsensiz() {
                $('#loadingPages').show();
                $('#loadingPages').addClass('overlayLoading');
                this.Data_Detail = [];
                try {
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_absensi_tanggal?idkaryawan=' + this.datarekapdetail.idkaryawan + '&tanggalMasuk=' + this.datarekapdetail.tanggal_format, this.requestHeaders);
                    if (res.status === 200) {
                        var tanggal_page = this.tanggalPage
                        var tanggal_akhir = this.tanggalAkhir
                        var tanggal_awal = this.tanggalAwal
                        if (tanggal_page == tanggal_akhir){
                            $("#buttonBesok").attr("disabled", true)
                        }else{
                            $("#buttonBesok").attr("disabled", false)
                        }
                        if (tanggal_page == tanggal_awal){
                            $("#buttonKemarin").attr("disabled", true)
                        }else{
                            $("#buttonKemarin").attr("disabled", false)
                        }
                        $('#loadingPages').hide();
                        $('#loadingPages').removeClass('overlayLoading');
                        var DataKaryawan = res.data.data;
	                    this.dataKaryawan = DataKaryawan;
	                    this.fotoAbsenMasuk = "https://storage.googleapis.com/" + this.dataKaryawan.cloudbucketIn + "/" + this.dataKaryawan.cloudnameIn
						this.fotoAbsenKeluar = "https://storage.googleapis.com/" + this.dataKaryawan.cloudbucketOut + "/" + this.dataKaryawan.cloudnameOut
                        this.Date_rekap = DataKaryawan.tanggal_absen_format;
                        this.Date_post = DataKaryawan.tanggal_absen;
                        var status = DataKaryawan.status;
                        this.status = status.toString();
                        this.masuk_kerja = DataKaryawan.masuk;
                        this.pulang_kerja = DataKaryawan.pulang;
                        this.selectedabsen = DataKaryawan.status;
                        this.lokasi = DataKaryawan.lokasi;
                        this.idkaryawan = DataKaryawan.idkaryawan;
                        if (this.status === '0') {
                            $('#tanpa_status').show();
                        } else {
                            $('#tanpa_status').hide();
                        }

	                    this.handleButtonHari(this.dataKaryawan.tanggal_absen, this.tanggalAwal, this.tanggalAkhir)
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPages').hide();
	                $('#loadingPages').removeClass('overlayLoading');
                }
            },
            async GetDetailAbsensiChangePage(date) {
                $('#loadingPages').show();
                $('#loadingPages').addClass('overlayLoading');
                this.Data_Detail = [];
                try {
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_absensi_tanggal?idkaryawan=' + this.datarekapdetail.idkaryawan + '&tanggalMasuk=' + date, this.requestHeaders);
                    if (res.status === 200) {
                        var tanggal_akhir = this.tanggalAkhir
                        var tanggal_awal = this.tanggalAwal
                        if (date == tanggal_akhir){
                            $("#buttonBesok").attr("disabled", true)
                        }else{
                            $("#buttonBesok").attr("disabled", false)
                        }
                        if (date == tanggal_awal){
                            $("#buttonKemarin").attr("disabled", true)
                        }else{
                            $("#buttonKemarin").attr("disabled", false)
                        }
                        $('#loadingPages').hide();
                        $('#loadingPages').removeClass('overlayLoading');
                        var DataKaryawan = res.data.data;
                        this.dataKaryawan = DataKaryawan;
                        this.fotoAbsen = "https://storage.googleapis.com/" + this.dataKaryawan.cloudbucket + "/" + this.dataKaryawan.cloudname
	                    this.fotoAbsenMasuk = "https://storage.googleapis.com/" + this.dataKaryawan.cloudbucketIn + "/" + this.dataKaryawan.cloudnameIn
	                    this.fotoAbsenKeluar = "https://storage.googleapis.com/" + this.dataKaryawan.cloudbucketOut + "/" + this.dataKaryawan.cloudnameOut
	                    this.Date_rekap = DataKaryawan.tanggal_absen_format;
                        this.Date_post = DataKaryawan.tanggal_absen;
                        this.tanggalPage = date;
                        var status = DataKaryawan.status;
                        this.status = status.toString();
                        this.masuk_kerja = DataKaryawan.masuk;
                        this.pulang_kerja = DataKaryawan.pulang;
                        this.selectedabsen = DataKaryawan.status;
                        this.lokasi = DataKaryawan.lokasi;
                        this.idkaryawan = DataKaryawan.idkaryawan;
                        if (this.status === '0') {
                            $('#tanpa_status').show();
                        } else {
                            $('#tanpa_status').hide();
                        }

	                    this.handleButtonHari(this.dataKaryawan.tanggal_absen, this.tanggalAwal, this.tanggalAkhir)
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPages').hide();
	                $('#loadingPages').removeClass('overlayLoading');
                }
            },
	        errorValidation() {
		        this.$v.selectedabsen.$touch()
		        this.$v.time_awal.$touch()
		        this.$v.time_akhir.$touch()
            	return this.$v.selectedabsen.$invalid ||
		            this.$v.time_awal.$invalid ||
		            this.$v.time_akhir.$invalid
	        },
            async UpdateStatus() {
            	if (this.errorValidation()) {
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
            		return
	            }
                $('#loadingPages').show();
                $('#loadingPages').addClass('overlayLoading');
                try {
                    const UpdateAbsen = new FormData;
                    UpdateAbsen.append('idkaryawan', this.idkaryawan);
                    UpdateAbsen.append('lokasi', this.lokasi);
                    UpdateAbsen.append('idlokasi', this.datarekapdetail.idlokasi);
                    UpdateAbsen.append('tanggal_absen', this.Date_post);
                    UpdateAbsen.append('waktu_masuk', this.$moment(this.Date_post + 'T' + this.time_awal + ':00').utc().format("YYYY-MM-DD HH:mm:ss"));
                    UpdateAbsen.append('waktu_keluar', this.$moment(this.Date_post + 'T' + this.time_akhir + ':00').utc().format("YYYY-MM-DD HH:mm:ss"));
                    UpdateAbsen.append('status_absensi', this.selectedabsen);
                    const res = await this.$axios.post(this.$baseurl + '/masterData/karyawan/update_status_absen_karyawan', UpdateAbsen, this.requestHeaders);
                    if (res.status === 200) {
                        $('#loadingPages').hide();
                        $('#loadingPages').removeClass('overlayLoading');
                        this.GetDetailAbsensiz();
                        $('#modalnotif').modal('hide');
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPages').hide();
	                $('#loadingPages').removeClass('overlayLoading');
                }
				this.smartTrackingClick("edit_status_absen",{"idkaryawan":this.idkaryawan});

			},
	        showFotoAbsen(url) {
            	this.pageSetting.detail = false
				this.pageSetting.absensi = true
		        this.fotoAbsensi = url
	        },
	        showDetailAbsensi() {
		        this.pageSetting.detail = true
		        this.pageSetting.absensi = false
		        this.pageSetting.maps = false

		        this.backButtonPressed(this.backrekapabsen)
	        },
	        showDetailLokasiAbsen(lat, lng) {
            	this.latlng.lat = lat
		        this.latlng.lng = lng

		        this.pageSetting.detail = false
		        this.pageSetting.absensi = false
		        this.pageSetting.maps = true
	        },
	        handleButtonHari(tanggalAbsen, tanggalAwal, tanggalAkhir) {
		        this.dateButton.showToday = this.$moment().isBetween(this.$moment(tanggalAwal).subtract(1, "days"), this.$moment(tanggalAkhir).add(1, "days"));
		        this.dateButton.today = this.$moment(tanggalAbsen).isSame(this.$moment().format("YYYY-MM-DD"))
		        this.dateButton.tomorrow = this.$moment(tanggalAbsen).isBefore(tanggalAkhir)
		        this.dateButton.yesterday = this.$moment(tanggalAbsen).isAfter(tanggalAwal)
	        }
        }
    }
</script>
<style scoped>
    .nav-bottom-wrapper {
        position: fixed;
	    left: 0;
        width: 100%;
        bottom: 64px;
        background: white;
        box-shadow: 0px -6px 12px rgba(0, 0, 0, 0.05);
    }
    
    .frame-foto-absen {
	    width: 100%;
	    height: 240px;
	    position: relative;
	    border: 1px solid rgba(200, 208, 221, 0.55);
	    border-radius: 4px
    }
    
    .foto-absen {
	    width: 100%;
	    position: absolute;
	    bottom: 0;
	    top: 0;
	    margin: auto 0;
	    background-size: contain;
	    background-repeat: no-repeat;
	    background-position: center;
    }

    .hideSection {
	    display: none;
    }

    .thumbnail-detail-absen {
	    position: relative;
	    background-size: cover;
	    height: 80px;
	    width: 80px;
	    background-repeat: no-repeat;
	    background-position: center;
	    border-radius: 4px;
    }

    .icon-expand-photo {
	    position: absolute;
	    bottom: 4px;
	    right: 4px;
    }
    .info-absen {
	    display: flex;
	    width: calc(100% - 80px);
    }
    .nav-bottom-wrapper {
	    box-shadow: none;
    }
</style>